"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["off"] = 0] = "off";
    LogLevel[LogLevel["fatal"] = 1] = "fatal";
    LogLevel[LogLevel["error"] = 2] = "error";
    LogLevel[LogLevel["warn"] = 3] = "warn";
    LogLevel[LogLevel["info"] = 4] = "info";
    LogLevel[LogLevel["debug"] = 5] = "debug";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
;
var ConsoleLogger = (function () {
    function ConsoleLogger(level) {
        this._logLevel = level;
    }
    ConsoleLogger.prototype.debug = function (message) {
        if (this._logLevel >= LogLevel.debug) {
            ConsoleLogger.print(message, "debug");
        }
    };
    ConsoleLogger.prototype.info = function (message) {
        if (this._logLevel >= LogLevel.info) {
            ConsoleLogger.print(message, "info");
        }
    };
    ConsoleLogger.prototype.warn = function (message) {
        if (this._logLevel >= LogLevel.warn) {
            ConsoleLogger.print(message, "warning");
        }
    };
    ConsoleLogger.prototype.error = function (message) {
        if (this._logLevel >= LogLevel.error) {
            ConsoleLogger.print(message, "error");
        }
    };
    ConsoleLogger.prototype.fatal = function (message) {
        if (this._logLevel >= LogLevel.fatal) {
            ConsoleLogger.print(message, "fatal");
        }
    };
    ConsoleLogger.print = function (message, appendix) {
        if (typeof message === "string") {
            console.log(ConsoleLogger.appendMessageString(message, appendix));
        }
        else {
            console.log(ConsoleLogger.appendMessageString("", appendix));
            console.log(message);
        }
    };
    ConsoleLogger.appendMessageString = function (message, appendix) {
        return "[" + appendix.toUpperCase() + "]" + message;
    };
    return ConsoleLogger;
}());
exports.ConsoleLogger = ConsoleLogger;
//# sourceMappingURL=consoleLogger.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/logger/consoleLogger.js
// module id = 1
// module chunks = 0